import request from '@/api/request'

//PC工作通-职位列表
export function jobEnrollList(data) {
    return request({
        url: '/web/job/enroll/list',
        method: 'GET',
        params: data
    })
}

//职PC工作通-职位详情
export function jobEnrollInfo(data) {
    return request({
        url: '/web/job/enroll/info',
        method: 'GET',
        params: data
    })
}

//PC工作通-入职的所有职位列表
export function jobCheckList(data) {
    return request({
        url: '/web/job/check/list',
        method: 'GET',
        params: data
    })
}

///PC工作通-面试同意
export function jobEnrollAuditUpdate(data) {
    return request({
        url: '/web/job/enroll/audit/update',
        method: 'POST',
         data
    })
}

///PC工作通-地址修改
export function jobEnrollAddressUpdate(data) {
    return request({
        url: '/web/job/enroll/address/update',
        method: 'POST',
         data
    })
}


///PC工作通-合同处理
export function jobEnrollContractUpdate(data) {
    return request({
        url: '/web/job/enroll/contract/update',
        method: 'POST',
         data
    })
}

export function jobEnrollAssesAdd(data) {
    return request({
        url: '/web/job/enroll/assess/add',
        method: 'POST',
         data
    })
}




//职位地址接口
export function jobaddressList(data) {
    return request({
        url: '/api/jobAddress/addressList',
        method: 'GET',
        params: data
    })
}

//职位收藏接口
export function addCollect(data) {
    return request({
        url: '/api/collect/addCollect',
        method: 'POST',
        data
    })
}

//职位详情推荐职位
export function recommendlist(data) {
    return request({
        url: '/api/job/recommend/list',
        method: 'GET',
        params: data
    })
}

//报名接口
export function collectaddEnroll(data) {
    return request({
        url: '/api/job/postEnroll',
        method: 'POST',
        data
    })
}